export const getDefaultValues = (exchangeConfigDetails) => ({
  TransactionExchangeConfigDestinationTransactionAmountTypeID:
    exchangeConfigDetails?.TransactionExchangeConfigDestinationTransactionAmountTypeID || -1,

  TransactionExchangeConfigSourceTransactionAmountTypeID:
    exchangeConfigDetails?.TransactionExchangeConfigSourceTransactionAmountTypeID || -1,

  TransactionExchangeConfigRate: exchangeConfigDetails?.TransactionExchangeConfigRate || '',

  TransactionExchangeConfigLabel: exchangeConfigDetails?.TransactionExchangeConfigLabel || '',
});
